import React, { useEffect, useMemo, useState, useCallback } from "react";
import "./Account.css";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { Navigate , useLocation } from "react-router-dom";
import { useLogin } from "../LoginProvider";

import CommandDetails from "./CommandDetails";

import Support from "../components/Support";
import ManageAccount from "../components/ManageAccount";

// Firebase
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  startAfter,
} from "firebase/firestore";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CarteRemise from "./CarteRemise";
import BankDetails from "./BankDetails";
import PurchaseHistory from "./PurchaseHistory";
// Imports nécessaires en haut du fichier si absents :
// en haut du fichier si pas déjà importés
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import ImageModal from "./ImageModal";

// --- Composant détails avec édition des quantités ---
function OrderDetailsInline({ order, onBack, onUpdated, money }) {
  const { user } = useLogin();
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);

  const [openImage, setOpenImage] = useState(false);
  const [sourceImage , setSourceImage] = useState("");

  const isPending = String(order?.Etat || "").toLowerCase() === "pending";

  // --- brouillon local des items (éditable)
  const [itemsDraft, setItemsDraft] = useState(
    Array.isArray(order?.OrdersItems)
      ? order.OrdersItems.map((it) => ({
          id: it.id,
          title: it.title,
          image: it.image,
          price: Number(it.price || 0),
          qty: Number(it.qty || 0),
          getDiscount : it.getDiscount ,
          maxiDiscount: Number(it.maxiDiscount)
        }))
      : []
  );
  //
  const [option, setOption] = useState(order.Option);
    const [formData, setFormData] = useState({
      livraison: { location: "", phone: "", fee: 0 },
      expedition: { country: "", phone: "" },
      boutique: { name: "", phone: "", store: "" }, // ⬅️ store ajouté
    });
 const locations = [{ name: "avedji", fee: 1000 } , {name: "Agoe", fee: 2000} , {name: "Hedjranawoe", fee: 1500}];

  // Expédition: pays (exemple)
  const countries = ["Niger", "Benin", "Burkina Faso", "Cote d'ivoire", "Ghana"];

  // Boutiques: à personnaliser
  const stores = [
    { id: "btq-1", name: "Cassablanca", address: "Juste a cote du cap d'essence de cassablanca" },
    { id: "btq-2", name: "Dekon",       address: "En Diagonale a l'immeuble haojue de dekon." },
    { id: "btq-3", name: "Baguida", address: "Face Orabank de Baguida" },
  ];

  useEffect(() => {
    if(order.Option === "livraison"){
      setFormData({livraison: { location: order.Adresse, phone: order.Telephone, fee: order.DeliveryFee } , expedition: { country: "", phone: "" },
      boutique: { name: "", phone: "", store: "" },});
    }
    if(order.Option === "expedition"){
      setFormData({expedition: { country: order.Adresse, phone: order.Telephone } , livraison: { location: "", phone: "", fee: 0 },
      boutique: { name: "", phone: "", store: "" },});
    }
    if(order.Option === "boutique"){
      setFormData({boutique: { name: order.name, phone: order.Telephone, store: order.Adresse } , livraison: { location: "", phone: "", fee: 0 },
      expedition: { country: "", phone: "" },});
    }
}, [order]);

  const locationsMap = useMemo(
    () => Object.fromEntries(locations.map(l => [l.name, l.fee])),
    [locations]
  );

  const handleChangeLocation = (group, field, value) => {
    if (group === "livraison" && field === "location") {
      const fee = locationsMap[value] ?? 0;
      setFormData(prev => ({
        ...prev,
        livraison: { ...prev.livraison, location: value, fee }
      }));
      return;
    }
    setFormData(prev => ({
      ...prev,
      [group]: { ...prev[group], [field]: value }
    }));
  };


  const selectedFee =
    option === "livraison" && formData.livraison.location
      ? locationsMap[formData.livraison.location] ?? 0
      : 0;


  //

  // champs “info livraison” (déjà présents dans ta version précédente)
  const [quartier, setQuartier] = useState(order?.Adresse || order?.ShippingAddress?.Quartier || "");
  const [phone, setPhone] = useState(order?.Telephone || order?.Phone || order?.phone_user || "");

  // totaux recalculés sur le brouillon
  const totalQty = itemsDraft.reduce((s, it) => s + Number(it.qty || 0), 0);
  //before remise total
  const beforeRemise = itemsDraft.reduce((s, it) => s + Number(it.qty * it.price || 0), 0)
  const subTotal = itemsDraft.reduce(
    (sum, it) => {
      const price = Number(it?.price ?? 0);
      const qty = Number(it.qty ?? 0);
      const base = qty * price;
  
      // user.discount > 0 ?
      const userHasDiscount = (user?.discount ?? 0) > 0;
  
      // Où sont stockées les infos de remise ? Sur product par défaut :
      const itemEligible = Boolean(it?.getDiscount); // true/false
      const percent = Number(it?.maxiDiscount ?? 0); // ex: 5,10,15
  
      if (userHasDiscount && itemEligible && percent > 0) {
        return sum + base * (1 - percent / 100);
      }
      return sum + base;
    }, 0
  );
  
  const shipping = Number(order?.DeliveryFee || 0);
  const grandTotal = subTotal + selectedFee;

  // helpers quantité
  const setQty = (id, q) => {
    let newQty = Math.max(0, parseInt(q || 0, 10));
    setItemsDraft((prev) => {
      const next = prev.map((it) => (it.id === id ? { ...it, qty: newQty } : it));
      // si 0 -> on supprime la ligne
      return next.filter((it) => it.qty > 0);
    });
  };
  const inc = (id) =>
    setItemsDraft((prev) => prev.map((it) => (it.id === id ? { ...it, qty: it.qty + 1 } : it)));
  const dec = (id) =>
    setItemsDraft((prev) => {
      const next = prev
        .map((it) => (it.id === id ? { ...it, qty: Math.max(0, it.qty - 1) } : it))
        .filter((it) => it.qty > 0);
      return next;
    });
  const removeLine = (id) =>
    setItemsDraft((prev) => prev.filter((it) => it.id !== id));

  // annuler (si pending)
  const cancelOrder = async () => {
    if (!isPending) return;
    if (!window.confirm("Annuler cette commande ?")) return;
    try {
      setSaving(true);
      await updateDoc(doc(db, "ecom_orders", order.id), {
        Etat: "Cancelled",
        updatedAt: serverTimestamp(),
      });
      onUpdated?.({ id: order.id, Etat: "Cancelled" });
      onBack();
    } catch (e) {
      console.error(e);
      alert("Échec de l'annulation.");
    } finally {
      setSaving(false);
    }
  };

  // enregistrement (quantités + infos)
  const saveEdits = async () => {
    if (!isPending) return;

    if (itemsDraft.length === 0) {
      alert("La commande ne peut pas être vide. Vous pouvez l'annuler.");
      return;
    }

    if(option === "livraison"){
      if(formData.livraison.location !== ""){
        if(formData.livraison.phone !== ""){
            try {
                setSaving(true);
                await updateDoc(doc(db, "ecom_orders", order.id), {
                  OrdersItems: itemsDraft,        
                  TotalQty: totalQty,               
                  TotalPrice: beforeRemise,
                  RemisePrice: Number(beforeRemise) - Number(grandTotal),            
                  Adresse: formData.livraison.location,                 
                  Telephone: formData.livraison.phone, 
                  DeliveryFee: formData.livraison.fee,
                  AfterTotal: grandTotal,      
                  UserDiscount: user.discount ?? Number(0), 
                  Option: option,
                  updatedAt: serverTimestamp(),
                });

                onUpdated?.({
                  id: order.id,
                  OrdersItems: itemsDraft,        
                  TotalQty: totalQty,               
                  TotalPrice: beforeRemise,
                  RemisePrice: Number(beforeRemise) - Number(grandTotal),            
                  Adresse: formData.livraison.location,                 
                  Telephone: formData.livraison.phone, 
                  AfterTotal: grandTotal, 
                  DeliveryFee: formData.livraison.fee,     
                  Option: option,
                  UserDiscount: user.discount ?? Number(0), 
                  updatedAt: serverTimestamp(), 
                });
                setEditing(false);
                onBack();
              } catch (e) {
                console.error(e);
                alert("Sauvegarde impossible.");
              } finally {
                setSaving(false);
              }
        }
        else{
          //entrez telephone
        }
      }
      else{
        //entrez location
      }
    }

    if(option === "expedition"){
      if(formData.expedition.country !== ""){
        if(formData.expedition.phone !== ""){
           try {
                setSaving(true);
                await updateDoc(doc(db, "ecom_orders", order.id), {
                  OrdersItems: itemsDraft,        
                  TotalQty: totalQty,               
                  TotalPrice: beforeRemise,
                  RemisePrice: Number(beforeRemise) - Number(grandTotal),            
                  Adresse: formData.expedition.country,                 
                  Telephone: formData.expedition.phone, 
                  AfterTotal: grandTotal,      
                  DeliveryFee: Number(0),
                  UserDiscount: user.discount ?? Number(0), 
                  Option: option,
                  updatedAt: serverTimestamp(),
                });

                onUpdated?.({
                  id: order.id,
                  OrdersItems: itemsDraft,        
                  TotalQty: totalQty,               
                  TotalPrice: beforeRemise,
                  RemisePrice: Number(beforeRemise) - Number(grandTotal),            
                  Adresse: formData.expedition.country,                 
                  Telephone: formData.expedition.phone, 
                  AfterTotal: grandTotal, 
                  DeliveryFee: Number(0),     
                  Option: option,
                  UserDiscount: user.discount ?? Number(0), 
                  updatedAt: serverTimestamp(), 
                });
                setEditing(false);
                onBack();
              } catch (e) {
                console.error(e);
                alert("Sauvegarde impossible.");
              } finally {
                setSaving(false);
              }
        }
        else{
          //entrez phone
        }
      }
      else{
        //entrez pays
      }
    }

    if(option === "boutique"){
       if(formData.boutique.store !== ""){
         if(formData.boutique.name !== ""){
           if(formData.boutique.phone !== ""){
             try {
                setSaving(true);
                await updateDoc(doc(db, "ecom_orders", order.id), {
                  OrdersItems: itemsDraft,        
                  TotalQty: totalQty,               
                  TotalPrice: beforeRemise,
                  RemisePrice: Number(beforeRemise) - Number(grandTotal),            
                  Adresse: formData.boutique.store,                 
                  Telephone: formData.boutique.phone, 
                  AfterTotal: grandTotal,    
                  name: formData.boutique.name,  
                  DeliveryFee: Number(0),
                  UserDiscount: user.discount ?? Number(0), 
                  Option: option,
                  updatedAt: serverTimestamp(),
                });

                onUpdated?.({
                  id: order.id,
                  OrdersItems: itemsDraft,        
                  TotalQty: totalQty,               
                  TotalPrice: beforeRemise,
                  RemisePrice: Number(beforeRemise) - Number(grandTotal),            
                  Adresse: formData.boutique.store,                 
                  Telephone: formData.boutique.phone, 
                  name: formData.boutique.name,
                  AfterTotal: grandTotal, 
                  DeliveryFee: Number(0),     
                  Option: option,
                  UserDiscount: user.discount ?? Number(0), 
                  updatedAt: serverTimestamp(), 
                });
                setEditing(false);
                onBack();
              } catch (e) {
                console.error(e);
                alert("Sauvegarde impossible.");
              } finally {
                setSaving(false);
              }
           }
           else{
            //entrez phone
           }
         }
         else{
          //entrez name
         }
       }
       else{
        //entrez boutique
       }
    }
  };

  return (

    <>
    <div className="order-details">
      <button className="btn-link" onClick={onBack}>&larr; Retour aux commandes</button>

      <div className="od-header">
        <h3>
          Commande n{"\u00B0"}{"\u00A0"}{order.code || order.id}
        </h3>
        
      </div>

      <div className="od-grid">
        {/* --- Colonne gauche : items avec édition des quantités --- */}
        <div className="od-left card">
          {itemsDraft.map((it) => (
            <div key={it.id} className="od-item">
              <img src={it.image || "/placeholder.webp"} alt={it.title} className="od-thumb" onClick={() => {setSourceImage(it.image) ; setOpenImage(true)}}/>
              <div className="od-info">
                <div className="od-title">{it.title.slice(0 , 15)}...</div>
                <div className="od-meta">
                  {money(it.price)}
                </div>

              </div>

              <div className="od-qty">
                <button className="qty-btn" onClick={() => dec(it.id)} disabled={!isPending || !editing}>−</button>
                <input
                  type="number"
                  min={0}
                  value={it.qty}
                  disabled={!isPending || !editing}
                  onChange={(e) => setQty(it.id, e.target.value)}
                />
                <button className="qty-btn" onClick={() => inc(it.id)} disabled={!isPending || !editing}>+</button>
              </div>

              <div className="od-line">
                {money(
                    it?.getDiscount
                      ? Number(it.price) * (1 - Number(it.maxiDiscount ?? it.MaxiDiscount ?? 0) / 100) * Number(it.qty)
                      : Number(it.price ) * Number(it.qty)
                  )}
              </div>

              {isPending && editing && (
                <button className="line-remove" title="Supprimer" onClick={() => removeLine(it.id)}>×</button>
              )}
            </div>
          ))}

          <div className="od-actions-row">
            <button className="btn" onClick={onBack}>Fermer les détails</button>
            {isPending && (
              <button className="btn-danger" disabled={saving} onClick={cancelOrder}>
                {saving ? "Annulation..." : "Annuler la commande"}
              </button>
            )}
          </div>
        </div>

        {/* --- Colonne droite : résumé + formulaire --- */}
        <aside className="od-right card">
          <h4>Résumé de la commande</h4>
          <div className="od-summary">
            <div><span>Produits</span><strong>{totalQty}</strong></div>
            <div><span>Sous Total</span><strong>{beforeRemise} FCFA</strong></div>
            <div><span>Remise</span><strong>{Number(beforeRemise) - Number(subTotal)} FCFA</strong></div>
            
            
            {
              order.Option === "livraison" ? 
              <div><span>Livraison</span><strong>{selectedFee ? money(selectedFee) : "---"}</strong></div>
              :
              ''
            }
            
            <div className="total"><span>Total</span><strong>{money(grandTotal)}</strong></div>
          </div>
         
          {/* <div className="od-form">
            <label>Quartier</label>
            <input
              type="text"
              placeholder="Ex: Agoe"
              value={quartier}
              disabled={!isPending || !editing}
              onChange={(e) => setQuartier(e.target.value)}
            />
            <label>Numéro à appeler</label>
            <input
              type="tel"
              placeholder="Ex: 90000000"
              value={phone}
              disabled={!isPending || !editing}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div> */}

          <div className="container-cpl">
      <form className="form-wrap-cpl" >
        <fieldset className="radio-group-cpl">
          <legend className="legend-cpl">Mode de réception</legend>

          <label className={`radio-item-cpl ${option === "livraison" ? "active-cpl" : ""}`}>
            <input
              type="radio"
              name="mode"
              value="livraison"
              checked={option === "livraison"}
              onChange={() => setOption("livraison")}
              className="radio-input-cpl"
              disabled={!editing}
            />
            <span className="radio-label-cpl">Livraison</span>
          </label>

          <label className={`radio-item-cpl ${option === "expedition" ? "active-cpl" : ""}`}>
            <input
              type="radio"
              name="mode"
              value="expedition"
              checked={option === "expedition"}
              onChange={() => setOption("expedition")}
              className="radio-input-cpl"
              disabled={!editing}
            />
            <span className="radio-label-cpl">Expédition</span>
          </label>

          <label className={`radio-item-cpl ${option === "boutique" ? "active-cpl" : ""}`}>
            <input
              type="radio"
              name="mode"
              value="boutique"
              checked={option === "boutique"}
              onChange={() => setOption("boutique")}
              className="radio-input-cpl"
              disabled={!editing}
            />
            <span className="radio-label-cpl">Recuperer</span>
          </label>
        </fieldset>

        <div className="panel-cpl">
          {option === "livraison" && (
            <>
            <br />
              <div className="grid-cpl">
                <div className="field-cpl">
                  <label htmlFor="livraison-location" className="label-cpl">Localisation</label>
                  <select
                    id="livraison-location"
                    className="input-cpl"
                    value={formData.livraison.location}
                    onChange={(e) => handleChangeLocation("livraison", "location", e.target.value)}
                    required
                    disabled={!editing}
                  >
                    <option value="">— Sélectionner —</option>
                    {locations.map(loc => (
                      <option key={loc.name} value={loc.name}>
                        {loc.name} — {loc.fee} FCFA
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field-cpl">
                  <label htmlFor="livraison-phone" className="label-cpl">Téléphone</label>
                  <input
                    id="livraison-phone"
                    className="input-cpl"
                    type="tel"
                    inputMode="tel"
                    placeholder="+228 90 00 00 00"
                    value={formData.livraison.phone}
                    onChange={(e) => handleChangeLocation("livraison", "phone", e.target.value)}
                    pattern="^\+?\d[\d\s\-()]{6,}$"
                    required
                    disabled={!editing}
                  />
                  
                </div>
              </div><br />

              <div className="fee-row-cpl" aria-live="polite">
                {formData.livraison.location ? (
                  <span className="fee-badge-cpl">
                    Frais de livraison : <strong>{selectedFee} FCFA</strong>
                  </span>
                ) : (
                  <span className="fee-muted-cpl">Sélectionnez une localisation pour voir les frais</span>
                )}
              </div>
            </>
          )}

          {option === "expedition" && (
          <>
          <br />
            <div className="grid-cpl">
              <div className="field-cpl">
                <label htmlFor="expedition-country" className="label-cpl">Pays</label>
                <select
                  id="expedition-country"
                  className="input-cpl"
                  value={formData.expedition.country}
                  onChange={(e) => handleChangeLocation("expedition", "country", e.target.value)}
                  required
                  disabled={!editing}
                >
                  <option value="">— Sélectionner —</option>
                  {countries.map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>

              <div className="field-cpl">
                <label htmlFor="expedition-phone" className="label-cpl">Téléphone</label>
                <input
                  id="expedition-phone"
                  className="input-cpl"
                  type="tel"
                  inputMode="tel"
                  placeholder="+229 12 34 56 78"
                  value={formData.expedition.phone}
                  onChange={(e) => handleChangeLocation("expedition", "phone", e.target.value)}
                  pattern="^\+?\d[\d\s\-()]{6,}$"
                  required
                  disabled={!editing}
                />
                
              </div>
            </div>
          </>
          )}

          {option === "boutique" && (
            <>
            <br />
            <div className="grid-cpl">
              <div className="field-cpl">
                <label htmlFor="boutique-store" className="label-cpl">Boutique de retrait</label>
                <select
                  id="boutique-store"
                  className="input-cpl"
                  value={formData.boutique.store}
                  onChange={(e) => handleChangeLocation("boutique", "store", e.target.value)}
                  required
                  disabled={!editing}
                >
                  <option value="">— Sélectionner —</option>
                  {stores.map(s => (
                    <option key={s.id} value={s.name}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field-cpl">
                <label htmlFor="boutique-name" className="label-cpl">Nom</label>
                <input
                  id="boutique-name"
                  className="input-cpl"
                  type="text"
                  placeholder="Nom et prénom"
                  value={formData.boutique.name}
                  onChange={(e) => handleChangeLocation("boutique", "name", e.target.value)}
                  required
                  disabled={!editing}
                />
              </div>

              <div className="field-cpl">
                <label htmlFor="boutique-phone" className="label-cpl">Téléphone</label>
                <input
                  id="boutique-phone"
                  className="input-cpl"
                  type="tel"
                  inputMode="tel"
                  placeholder="90 00 00 00"
                  value={formData.boutique.phone}
                  onChange={(e) => handleChangeLocation("boutique", "phone", e.target.value)}
                  pattern="^\+?\d[\d\s\-()]{6,}$"
                  required
                  disabled={!editing}
                />
              </div>
            </div>
            </>
          )}
        </div>

        <div className="actions-cpl">
          {/* <button type="submit" className="btn-cpl">Valider</button> */}
        </div>
      </form>
    </div>
          <br />
          {isPending ? (
            <div className="od-buttons">
              {!editing ? (
                <button className="btn-primary" onClick={() => setEditing(true)}>
                  Éditer la commande
                </button>
              ) : (
                <button className="btn-primary" disabled={saving} onClick={saveEdits}>
                  {saving ? "Enregistrement..." : "Enregistrer"}
                </button>
              )}
            </div>
          ) : (
            <div className="muted" style={{ marginTop: 8 }}>
              Cette commande n’est plus modifiable.
            </div>
          )}
        </aside>
      </div>
    </div>

    <ImageModal
            open={openImage}
            src={sourceImage}
            alt="Ma belle image"
            onClose={() => setOpenImage(false)}
          />
    </>
  );
}



const PAGE_SIZE = 120;

export default function Account() {
  const { user } = useLogin();
  const { state, search } = useLocation();

const from = state?.from;
  const [active, setActive] = useState(from);

  const [openDetails, setOpenDetails] = useState(false);
const [selectedOrder, setSelectedOrder] = useState(null);

const handleSave = (data) => {
    // ici: sauvegarde Firestore / API
    
  };


  useEffect(() => {
  setActive(from);
}, [from]);

  // ---- Orders state
  const [orders, setOrders] = useState([]);          // [{id, code, TotalPrice, Etat, createdAt, ...}]
  const [loading, setLoading] = useState(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const [nextCursor, setNextCursor] = useState(null); // dernier doc pour pagination
  const [hasMore, setHasMore] = useState(true);

  const fmtDate = useCallback((ts) => {
    try {
      const d = ts?.toDate ? ts.toDate() : new Date(ts);
      return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
    } catch {
      return "";
    }
  }, []);

  const money = useCallback((v) => {
    const n = Number(v || 0);
    return `${n.toLocaleString("fr-FR")} FCFA`;
  }, []);

  // ---- Fetch (first page)
  useEffect(() => {
    if (!user) return;
    let cancelled = false;

    const fetchFirst = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "ecom_orders"),
          where("uid", "==", user.id),
          limit(PAGE_SIZE)
        );
        const snap = await getDocs(q);
        if (cancelled) return;

        let rows = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        const getMe = rows.filter(item => item.Etat !== "Cancelled");
        setOrders(getMe);
        setFirstLoadDone(true);

        const last = snap.docs[snap.docs.length - 1] || null;
        setNextCursor(last);
        setHasMore(Boolean(last)); // si pas de last, plus de pages
      } catch (e) {
        console.error("fetch orders error:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchFirst();
    return () => { cancelled = true; };
  }, [user]);

  // ---- Fetch next page
  const loadMore = async () => {
    if (!user || !nextCursor || loading) return;
    setLoading(true);
    try {
      const q = query(
        collection(db, "ecom_orders"),
        where("uid", "==", user.id),
        startAfter(nextCursor),
        limit(PAGE_SIZE)
      );
      const snap = await getDocs(q);
      const rows = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setOrders((prev) => [...prev, ...rows]);

      const last = snap.docs[snap.docs.length - 1] || null;
      setNextCursor(last);
      setHasMore(Boolean(last));
    } catch (e) {
      console.error("load more orders error:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
        document.title ="Profil - "+ user?.name;
      }, [user]);

  if (!user) return <Navigate to="/" replace />;

  return (
    <>
    
      <NavBar />

      <div className="account-container">
        {/* Menu gauche */}
        <aside className="account-menu">
          <button
            className={`account-menu-item ${active === "compte" ? "active" : ""}`}
            onClick={() => setActive("compte")}
          >
            Compte
          </button>
          <button
            className={`account-menu-item ${active === "commande" ? "active" : ""}`}
            onClick={() => setActive("commande")}
          >
            Commandes
          </button>
          <button
            className={`account-menu-item ${active === "support" ? "active" : ""}`}
            onClick={() => setActive("support")}
          >
            Support
          </button>
          <button
            className={`account-menu-item ${active === "carte" ? "active" : ""}`}
            onClick={() => setActive("carte")}
          >
            Carte
          </button>
        </aside>

        {/* Contenu */}
        <section className="account-content">
          {active === "compte" && (
            <div>
              <ManageAccount onSubmit={handleSave} />
            </div>
          )}

          {active === "commande" && (
            <PurchaseHistory />
)}


          {active === "support" && (
            <div>
              <Support />
              
            </div>
          )}

          

          {active === "carte"
            ? 
            <div><h4>Contacter nous pour avoir votre carte de fidelité...Merci</h4></div>
              // <BankDetails />
            
            // (user?.carteNumber != null
            //     ? 
            //     <div style={{display:"grid",placeItems:"center",minHeight:"10vh",padding:16}}>
            //           <CarteRemise
            //             name={user?.carteName}
            //             code={user?.carteNumber}          
            //             logo="/images/dollarstore.jpg"           
            //             disclaimer="La carte Dollarstore est strictement personnelle"
            //             format="CODE128"             
            //           />
            //         </div>
            //     : <div><h4>Contacter nous pour avoir votre carte de fidelité...Merci</h4></div>)
            : null}

        </section>
      </div>


    

      <Footer />
    </>
  );
}
